export default "__VITE_ASSET__OfXe_oEG__"